import { getVaildEnv } from '.';
let appConfig;
export function getAppConfig() {
    return appConfig;
}
export function setAppConfig(config) {
    appConfig = { ...config };
    appConfig.env = getVaildEnv(config?.env || 'prod');
}
const baseApiKeys = [
    'userId',
    'userName',
    'userSystem',
    'appCode',
    'panelCode',
];
const bucApiKeys = ['bucToken', ...baseApiKeys];
const moziApiKeys = ['moziToken', ...baseApiKeys];
const accountKeyMap = {
    mozi: moziApiKeys,
    buc: bucApiKeys,
};
export function getQueryConfig(userSystem) {
    const keys = accountKeyMap[userSystem] || baseApiKeys;
    return keys.reduce((prev, cur) => {
        // @ts-ignore
        prev[cur] = appConfig[cur];
        return prev;
    }, {});
}
